<template>
  <div>
      <a-card :title="`Accounts for ${contracts.name} aplication!`" :bordered="false">
        <a-button type="primary" size="small" slot="extra" @click="visible = true">Add new account</a-button>
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Email</th>
              <th scope="col">Rooms</th>
              <th scope="col">Account type</th>
              <th scope="col">Add/View/Edit</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in contracts.accounts" :key="i">
              <th scope="row">{{item.id}}</th>
              <th scope="row">{{item.account_email}}</th>
              <th scope="row">{{item.rooms.length}}</th>
              <th scope="row">{{item.is_personal == 'YES' ? 'Personal Account':'App Account' }}</th>
              <th scope="row"><router-link :to="{ path: '/contracts/'+appid+'/accounts/'+item.id}" class="btn-info btn-sm" exact>Open Account</router-link></th>
            </tr>
          </tbody>
        </table>

      </a-card>
      <a-modal
            :footer="null"
            title="Add new account!"
            :visible="visible"
            @cancel="cancel"
            >
            <a-row>
              <a-form :form="form" @submit="addNewAccount">

                <!--<a-form-item label="Inactive Rooms">
                    <a-select
                        v-decorator="[
                        'account_type',
                        { initialValue:'1',rules: [{ required: true, message: 'Please select room!' }] },
                        ]"
                    >
                        <a-select-option value="1" key="1" selected>
                           Basic
                        </a-select-option>
                        <a-select-option value="2" key="2" >
                           Licensed
                        </a-select-option>
                    </a-select>
                </a-form-item> -->
                <a-form-item label="Email">
                    <a-input type="email"
                        v-decorator="['email', { rules: [{ required: true, message: 'Please insert email!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Zoom Key">
                    <a-input
                        v-decorator="['zoom_key', { rules: [{ required: true, message: 'Please insert zoom key!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Zoom secret">
                    <a-input
                        v-decorator="['zoom_secret', { rules: [{ required: true, message: 'Please insert zoom secret!' }] }]"
                    />
                </a-form-item>
                <a-button type="primary" html-type="submit">
                    Submit
                </a-button>
              </a-form>
          </a-row>
        </a-modal>
  </div>
</template>
<script>

import API from '../../../services/api';

export default {
  data() {
    return {
      appid: this.$route.params.id,
      loading: false,
      contracts:{},
      visible:false,
      form: this.$form.createForm(this),
    }
  },
  created() {
    this.getAccounts()
  },
  methods: {
    getAccounts(){
      API.get(`/api/admin/contracts/${this.appid}/accounts`)
      .then(response => {
        console.log(response,"jkjj")
        this.contracts = response.data;
      })
    },
    addNewAccount(e){
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          API.post(`/api/admin/contracts/${this.appid}/accounts`,values).then(res => {
            if(res.status && res.status === 201){
              this.$message.success('Inserted successfully!')
              this.getAccounts()
              this.visible = false
              this.resetForm()
            }else{
              this.$message.warning('This account exist!')
              this.getAccounts()
            }
          })
        }
      })
    },
    addNewRoom(){
      API.post(`/api/admin/contracts`)
      .then(response => {
        console.log(response)
        //this.contracts = response.data
      })
    },
    deleteAccount(id){
      API.delete(`/api/admin/contracts/account/${id}`)
      .then(response => {
       
      })
    },
    addNewRoom(){
      API.post(`/api/admin/contracts`)
      .then(response => {
        console.log(response)
        //this.contracts = response.data
      })
    },
    cancel(){
      this.visible = false
    },
    async resetForm(){
       this.form = {
          email:'',
          zoom_key:'',
          zoom_secret:''
        }
    },
  },
};
</script>
<style>
</style>
